// California Business and Professions Code 22442(b)(3) requires the
// consultant's "not an attorney" statement in 10-point boldface on the
// face of the contract, and 22442.2(c) requires a clear and conspicuous
// version in advertisements. The wording lives here so the app, footers
// and checkout say the same thing.
//
// The consultant is a person who works with VisaGenius, not the company,
// so the statement is about "an immigration consultant" and is scoped to
// the plan that uses one (Silver). "plan" is for screens inside the
// purchase flow; "site" is for footers, where the reader may be looking
// at any plan.

export const CONSULTANT_PLAN_STATEMENT =
  "Your petition is prepared by an immigration consultant, who is not an attorney and may not perform the legal services that an attorney performs.";

export const CONSULTANT_SITE_STATEMENT =
  "Silver plan services are provided by an immigration consultant, who is not an attorney and may not perform the legal services that an attorney performs.";

export function ConsultantNotice({
  className = "",
  color,
  scope = "site",
}: {
  className?: string;
  color?: string;
  scope?: "plan" | "site";
}) {
  return (
    <p
      className={className}
      style={{ fontSize: "10pt", lineHeight: 1.4, fontWeight: 700, ...(color ? { color } : {}) }}
      data-testid="consultant-notice"
    >
      {scope === "plan" ? CONSULTANT_PLAN_STATEMENT : CONSULTANT_SITE_STATEMENT}
    </p>
  );
}

export default ConsultantNotice;
